import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";

const HEAD_VARIANTS = {
	default: "z-[2] relative",
	sticky: "sticky top-0 z-[2]",
};

interface AccordionProps {
	head: {
		title: string;
		variant?: keyof typeof HEAD_VARIANTS;
	};
	children?: any;
}

const Accordion = ({ head, children }: AccordionProps) => {
	const [visible, setVisible] = useState(false);
	return (
		<div className="flex flex-col border-b-2 border-gray">
			<div
				onClick={() => setVisible(!visible)}
				className={`cursor-pointer rounded-md flex items-center gap-8 justify-between px-6 py-4 transition-all hover:bg-gray-background bg-white ${
					visible && "shadow"
				} ${HEAD_VARIANTS[head?.variant || "default"]}`}
			>
				<strong>{head.title}</strong>
				<motion.div
					className="w-8 h-8 flex justify-center items-center relative overflow-hidden rounded-full"
					animate={visible ? "rotated" : "default"}
					variants={{
						default: {
							rotate: 0,
						},
						rotated: {
							rotate: 180,
						},
					}}
				>
					<motion.div
						animate={visible ? "rotated" : "default"}
						variants={{
							default: {
								opacity: 0,
							},
							rotated: {
								opacity: 0.2,
							},
						}}
						className="absolute inset-0 bg-primary shadow"
					></motion.div>
					<i
						style={{ zIndex: 1, marginTop: 2 }}
						className="far fa-angle-down"
					></i>
				</motion.div>
			</div>
			<AnimatePresence>
				{visible && (
					<motion.div
						initial={{ height: 0, y: -20 }}
						animate={{ height: "auto", y: 0 }}
						exit={{ height: 0, y: -20 }}
						className="overflow-hidden relative z-[1]"
					>
						<hr className="border-gray border-1" />
						<div className="p-6">{children}</div>
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};

export default Accordion;
